<template>
  <a-alert message="Information" description="Our Dashboard is Coming Soon" type="info" showIcon />
</template>

<script>
export default {
  name: "admin-page",
};
</script>
